<form #reportForm="ngForm">
	<section class="report-form">
		<section class="row">
			<section class="col-12 bottom-align-content">
				<div class="bottom-content">
					<section>
						<label for="name" class="text-12" dcrHTMLKey="LABEL_USER_NAME">Your Name</label>
					</section>
					<input
						[disabled]="disableReportGeneration"
						[readonly]="isNameReadonly"
						type="text"
						class="col-22 form-control"
						id="name"
						required
						[(ngModel)]="model.clientName"
						#nameModel="ngModel"
						name="name"
					/>
					<div [hidden]="nameModel.valid" class="alert-danger" dcrHTMLKey="LABEL_USER_NAME_MISSING">Name is required</div>
				</div>
			</section>
			<section class="col-12">
				<section>
					<label for="clientName" class="text-12" dcrHTMLKey="LABEL_CLIENT_NAME">Your Report Description <span class="text-12">(optional)</span> </label>
				</section>
				<input
					[disabled]="disableReportGeneration"
					type="text"
					class="col-22 form-control"
					id="clientName"
					[(ngModel)]="model.advisorName"
					name="clientName"
					#clientModel="ngModel"
				/>
			</section>
			<section class="col-12" *ngIf="showFirmName">
				<section>
					<label for="firmName" class="text-12" dcrHTMLKey="LABEL_FIRM_NAME">Your Firm's Name</label>
				</section>
				<input
					[disabled]="disableReportGeneration"
					[readonly]="isFirmNameReadonly"
					type="text"
					class="form-control col-22"
					id="firmName"
					[required]="firmNameRequired"
					[(ngModel)]="model.firm"
					#firmModel="ngModel"
					name="firm"
				/>
				<div [hidden]="firmModel.valid" class="alert-danger" dcrHTMLKey="LABEL_FIRM_NAME_MISSING">Name is required</div>
			</section>
		</section>
	</section>
</form>
